import type { TypedDocumentNode } from '@apollo/client';
import { gql, useLazyQuery } from '@apollo/client';
import { useCallback } from 'react';
import type { QueryUserPortfolioFilterArgs, UserPortfolioFilter } from '@/types/GraphqlSchema';

const USER_PORTFOLIO_FILTER_QUERY: TypedDocumentNode<
  { userPortfolioFilter: UserPortfolioFilter },
  QueryUserPortfolioFilterArgs
> = gql`
  query UserPortfolioFilter($id: ID!) {
    userPortfolioFilter(id: $id) {
      id
      uuid
      userId
      filters {
        assets
        basins
        countries
        companies
        developmentStatuses
        npvMax
        npvMin
        operator
        opportunities
        productionMax
        productionMin
        reservesMax
        reservesMin
        resourceThemes
        shoreStatuses
      }
      createdAt
      updatedAt
    }
  }
`;

export const useLoadPortfolioBridge = () => {
  const [loadQuery, { loading, error, data }] = useLazyQuery(USER_PORTFOLIO_FILTER_QUERY);

  const loadPortfolioBridge = useCallback(
    async (uuid: string): Promise<UserPortfolioFilter | null> => {
      try {
        const result = await loadQuery({
          variables: { id: uuid },
        });

        return result.data?.userPortfolioFilter || null;
      } catch (err) {
        console.error('Error loading portfolio bridge:', err);
        return null;
      }
    },
    [loadQuery],
  );

  return {
    loadPortfolioBridge,
    loading,
    error,
    data: data?.userPortfolioFilter,
  };
};
